// extracted by mini-css-extract-plugin
export default {"confirmSaveModal":"confirmSaveModal-rn9v_","title":"title-fBP89","text":"text-VJGO9","header":"header-AV741","footer":"footer-ZsZsu"};